import http from "./http.config";

export type VendorRole = {
  id: number | string;
  label: string;
};

export const fetchRoles = (params: Record<string, unknown> = {}) =>
  http.get("/vendors/roles", { params }).then((res) => res.data as VendorRole[]);

function asArray<T = unknown>(value: unknown): T[] {
  return Array.isArray(value) ? (value as T[]) : [];
}

function asString(value: unknown, fallback = "") {
  if (typeof value === "string" || typeof value === "number") return String(value);
  return fallback;
}

export function normalizeRoles(payload: unknown): VendorRole[] {
  const root = (payload as any) ?? {};
  const list =
    (root as any)?.roles ??
    (root as any)?.data?.roles ??
    (root as any)?.data ??
    (root as any)?.data?.data ??
    root;

  return asArray<VendorRole>(list)
    .map((r: any) => ({
      id: r?.id as number | string | undefined,
      label: asString(r?.label, "").trim(),
    }))
    .filter((r) => r.id !== undefined && r.label !== "") as VendorRole[];
}
